import { highchartsOptionsBaseColor, highchartsOptionsStyleColor } from "@portal/helpers/highchartsColors";
import { RiskLevel } from "@portal/types/robot/IRobotEnums";

const carefulPessimisticAmount = -2.0;
const carefulExpectedAmount = 4.05;
const carefulOptimisticAmount = 10.1;

const balancedPessimisticAmount = -3.9;
const balancedExpectedAmount = 4.88;
const balancedOptimisticAmount = 13.7;

const offensivePessimisticAmount = -7.3;
const offensiveExpectedAmount = 5.7;
const offensiveOptimisticAmount = 18.7;

const extraOffensivePessimisticAmount = -9.8;
const extraOffensiveExpectedAmount = 6.25;
const extraOffensiveOptimisticAmount = 22.3;

const getGraphMin = () => {
  return Math.min(
    carefulPessimisticAmount,
    balancedPessimisticAmount,
    offensivePessimisticAmount,
    extraOffensivePessimisticAmount,
  );
};

const getGraphMax = () => {
  return Math.max(carefulOptimisticAmount, balancedOptimisticAmount, offensiveOptimisticAmount, extraOffensiveOptimisticAmount);
};

export const optimisticYield = (riskLevel: RiskLevel): number => {
  switch (riskLevel.toString()) {
    case RiskLevel[RiskLevel.Careful]:
      return carefulOptimisticAmount;
    case RiskLevel[RiskLevel.Balanced]:
      return balancedOptimisticAmount;
    case RiskLevel[RiskLevel.Offensive]:
      return offensiveOptimisticAmount;
    case RiskLevel[RiskLevel.ExtraOffensive]:
      return extraOffensiveOptimisticAmount;
    default:
      return 0;
  }
};

export const expectedYield = (riskLevel: RiskLevel): number => {
  switch (riskLevel.toString()) {
    case RiskLevel[RiskLevel.Careful]:
      return carefulExpectedAmount;
    case RiskLevel[RiskLevel.Balanced]:
      return balancedExpectedAmount;
    case RiskLevel[RiskLevel.Offensive]:
      return offensiveExpectedAmount;
    case RiskLevel[RiskLevel.ExtraOffensive]:
      return extraOffensiveExpectedAmount;
    default:
      return 0;
  }
};

export const pessimisticYield = (riskLevel: RiskLevel): number => {
  switch (riskLevel.toString()) {
    case RiskLevel[RiskLevel.Careful]:
      return carefulPessimisticAmount;
    case RiskLevel[RiskLevel.Balanced]:
      return balancedPessimisticAmount;
    case RiskLevel[RiskLevel.Offensive]:
      return offensivePessimisticAmount;
    case RiskLevel[RiskLevel.ExtraOffensive]:
      return extraOffensivePessimisticAmount;
    default:
      return 0;
  }
};

export const AgreementDetailsData = (riskLevel: RiskLevel) => {
  return {
    title: null,
    chart: {
      type: "column",
      ...highchartsOptionsBaseColor(),
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    yAxis: {
      min: getGraphMin(),
      max: getGraphMax(),
      title: null,
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
      visible: true,
      plotLines: [
        {
          color: "#606060",
          width: 1,
          value: 0,
        },
      ],
    },
    xAxis: {
      type: "category",
      gridLineWidth: 0,
      lineColor: "transparent",
      tickColor: "transparent",
      labels: { style: highchartsOptionsStyleColor() },
    },
    plotOptions: {
      column: {
        threshold: 0,
      },
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y:.1f}%",
        },
      },
    },
    series: [
      {
        colorByPoint: true,
        data: [
          { name: "Dårlig", y: pessimisticYield(riskLevel), color: "#ff6a00" },
          { name: "Forventet", y: expectedYield(riskLevel), color: "#5900ff" },
          { name: "Bra", y: optimisticYield(riskLevel), color: "#5900ff" },
        ],
      },
    ],
  };
};
